import { auth } from "../db";
import API_URL from "../api/config.js";

function err(e) {
  return { success: false, error: e };
}

async function getUsageSummary(from, to) {
  if (!auth.currentUser) {
    return err("You must be signed in to view usage.");
  }

  let token;
  try {
    token = await auth.currentUser.getIdToken();
  } catch (e) {
    return err("Your session has expired. Please sign in again.");
  }

  const query = from && to ? `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}` : "";

  let response;
  try {
    response = await fetch(`${API_URL}/admin/usage${query}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (e) {
    return err("Could not reach the server, so usage could not be loaded.");
  }

  let payload;
  try {
    payload = await response.json();
  } catch (e) {
    return err("The server returned an unreadable response.");
  }

  if (!response.ok) {
    return err(payload.error || `Request failed with status ${response.status}`);
  }

  return { success: true, data: payload };
}

export default {
  getUsageSummary,
};



// WEBPACK FOOTER //
// ./src/Firestore/Usage.js